import { Action } from '@ngrx/store';
import { GeneralApiResponseInterface, GeneralTableQueryParams, TableQueryParams } from '../../layout/main/main.model';
import {
  ClientInterface,
  DeviceCRUDInterface,
  DeviceInterface,
  DeviceStatusInterface,
  DeviceTypeInterface,
  ConnectionProfileInterface,
  LineInterface,
  SiteInterface,
} from './device.model';
import {
  CustomDeviceManagementFilterOutputInterface,
  DeviceManagementInterface,
} from '../../view/device-management/device-management.model';
import { TabRowInterface } from '../../shared/component/side-config-bar/side-config-bar.model';
import { BulkResponseDataInterface } from '../../shared/model/interface/crud-response-interface.model';

export enum DeviceActionTypes {
  GetDevices = '[Device] Get Devices',
  GetDevicesCompleted = '[Device] Get Devices Completed',

  GetDevice = '[Device] Get Device',
  GetDeviceCompleted = '[Device] Get Device Completed',
  GetDeviceForMessageModal = '[Device] Get Device for Message Modal',
  GetDeviceForMessageModalCompleted = '[Device] Get Device for Message Modal Completed ',
  GetDevicesForMessageSchedulerModal = '[Device] Get Device for Message Scheduler Modal',
  GetDevicesForMessageSchedulerModalCompleted = '[Device] Get Device for Message Scheduler Modal Completed ',
  SendDeviceScheduleRequests = '[Device] Send Device Schedule Request',
  SendDeviceScheduleRequestsCompleted = '[Device] Send Device Schedule Request Completed ',
  GetDeviceStatusesForGrid = '[Device] Get Device statuses For Grid',
  GetDeviceStatusesForGridCompleted = '[Device] Get Device statuses For Grid Completed ',

  CreateDevice = '[Device] Create Device',
  CreateDeviceCompleted = '[Device] Create Device Completed',
  UpdateDevice = '[Device] Update Device',
  UpdateDeviceCompleted = '[Device] Update Device Completed',
  UpdateBulkDevice = '[Device] Update Bulk Device',
  UpdateBulkDeviceCompleted = '[Device] Update Bulk Device Completed',
  DeleteDevice = '[Device] Delete Device',
  DeleteDeviceCompleted = '[Device] Delete Device Completed',
  SetSelectedFilters = '[Device] Set Selected Filters',
  SetTableSettings = '[Device] Set Table Settings',
  GetDeviceTypes = '[Device] Get Device Types',
  GetDeviceTypesCompleted = '[Device] Get Device Types Completed',
  FetchDevicesByMac = '[Device] Fetch Devices By Mac',
  FetchDevicesByMacCompleted = '[Device] Fetch Devices By Mac Completed',

  GetClients = '[Device] Get Clients',
  GetClientsCompleted = '[Device] Get Clients Completed',
  GetSites = '[Device] Get Sites',
  GetSitesCompleted = '[Device] Get Sites Completed',
  GetLines = '[Device] Get Lines',
  GetLinesCompleted = '[Device] Get Lines Completed',
  GetConnectionProfiles = '[Device] Get ConnectionProfiles',
  GetConnectionProfilesCompleted = '[Device] Get ConnectionProfiles Completed',

  RegisterDevices = '[Device] Register Devices',
  RegisterDevicesCompleted = '[Device] Get Registered Devices Completed',
  SendMessageToDevice = '[Device] Send Message to Device',
  SendMessageToDeviceCompleted = '[Device] Get Results of Send Message to device request Completed',
  GetFirmwares = '[Device] Get Firmwares',
  GetFirmwaresCompleted = '[Device] Get Firmwares Completed',
  UploadFirmware = '[Device] Upload Firmware',
  UploadFirmwareCompleted = '[Device] Upload Firmware Completed',
  AbortUploadFirmware = '[Device] Abort Upload Firmware',
  AbortUploadFirmwareCompleted = '[Device] Abort Upload Firmware Completed',
  ClearState = '[Device] Clear State',
  FetchError = '[Device] Fetch Error',
}

export class GetDevices implements Action {
  readonly type = DeviceActionTypes.GetDevices;

  constructor(
    public filters: CustomDeviceManagementFilterOutputInterface,
    public query: TableQueryParams = {
      page: 1,
      pageSize: 10,
    },
    public timezone: string,
  ) {}
}

export class GetDevicesCompleted implements Action {
  readonly type = DeviceActionTypes.GetDevicesCompleted;

  constructor(public deviceList: DeviceInterface[], public itemTotal: number) {}
}

export class GetDevice implements Action {
  readonly type = DeviceActionTypes.GetDevice;

  constructor(public deviceId: number) {}
}

export class GetDeviceCompleted implements Action {
  readonly type = DeviceActionTypes.GetDeviceCompleted;

  constructor(public response: GeneralApiResponseInterface<DeviceInterface>) {}
}

export class GetDeviceForMessageModal implements Action {
  readonly type = DeviceActionTypes.GetDeviceForMessageModal;
  constructor(public deviceId: number, public refreshCommand: boolean) {}
}

export class GetDeviceForMessageModalCompleted implements Action {
  readonly type = DeviceActionTypes.GetDeviceForMessageModalCompleted;

  constructor(
    public device: GeneralApiResponseInterface<DeviceInterface>,
    public deviceStatus: GeneralApiResponseInterface<DeviceStatusInterface[]>,
    public refreshCommand: boolean,
  ) {}
}
export class GetDeviceStatusesForGrid implements Action {
  readonly type = DeviceActionTypes.GetDeviceStatusesForGrid;
  constructor(public deviceIds: number[]) {}
}

export class GetDeviceStatusesForGridCompleted implements Action {
  readonly type = DeviceActionTypes.GetDeviceStatusesForGridCompleted;

  constructor(
    public deviceStatuses: GeneralApiResponseInterface<DeviceStatusInterface[]>,
  ) {}
}

export class GetDevicesForMessageSchedulerModal implements Action {
  readonly type = DeviceActionTypes.GetDevicesForMessageSchedulerModal;
  constructor(public deviceIds: number[], public refreshCommand: boolean) {}
}

export class GetDevicesForMessageSchedulerModalCompleted implements Action {
  readonly type = DeviceActionTypes.GetDevicesForMessageSchedulerModalCompleted;

  constructor(
    public deviceStatuses: GeneralApiResponseInterface<DeviceStatusInterface[]>,
    public refreshCommand: boolean,
  ) {}
}

export class SendDeviceScheduleRequests implements Action {
  readonly type = DeviceActionTypes.SendDeviceScheduleRequests;
  constructor(public deviceIds: number[], public messageText: string) {}
}

export class SendDeviceScheduleRequestsCompleted implements Action {
  readonly type = DeviceActionTypes.SendDeviceScheduleRequestsCompleted;

  constructor(public deviceResults: GeneralApiResponseInterface<DeviceStatusInterface[]>) {}
}

export class CreateDevice implements Action {
  readonly type = DeviceActionTypes.CreateDevice;

  constructor(public payload: DeviceInterface) {}
}

export class CreateDeviceCompleted implements Action {
  readonly type = DeviceActionTypes.CreateDeviceCompleted;

  constructor(public response: GeneralApiResponseInterface<{}>) {}
}

export class UpdateDevice implements Action {
  readonly type = DeviceActionTypes.UpdateDevice;

  constructor(public payload: DeviceInterface, public id: number) {}
}

export class UpdateDeviceCompleted implements Action {
  readonly type = DeviceActionTypes.UpdateDeviceCompleted;

  constructor(public response: GeneralApiResponseInterface<DeviceInterface>) {}
}

export class UpdateBulkDevice implements Action {
  readonly type = DeviceActionTypes.UpdateBulkDevice;

  constructor(public devices: Partial<DeviceCRUDInterface>[]) {}
}

export class UpdateBulkDeviceCompleted implements Action {
  readonly type = DeviceActionTypes.UpdateDeviceCompleted;

  constructor(public response: BulkResponseDataInterface) {}
}

export class DeleteDevice implements Action {
  readonly type = DeviceActionTypes.DeleteDevice;
  constructor(public payload: number[]) {}
}

export class DeleteDeviceCompleted implements Action {
  readonly type = DeviceActionTypes.DeleteDeviceCompleted;
  constructor(public deletedDevices: any[]) {}
}

export class SetSelectedFilters implements Action {
  readonly type = DeviceActionTypes.SetSelectedFilters;
  constructor(public filters: CustomDeviceManagementFilterOutputInterface) {}
}

export class SetTableSettings implements Action {
  readonly type = DeviceActionTypes.SetTableSettings;
  constructor(public payload: TabRowInterface[], public setAsDefault: boolean) {}
}

export class GetDeviceTypes implements Action {
  readonly type = DeviceActionTypes.GetDeviceTypes;
}

export class GetDeviceTypesCompleted implements Action {
  readonly type = DeviceActionTypes.GetDeviceTypesCompleted;
  constructor(public data: DeviceTypeInterface[]) {}
}

export class GetClients implements Action {
  readonly type = DeviceActionTypes.GetClients;
  constructor(public scwEnv: string) {}
}

export class GetClientsCompleted implements Action {
  readonly type = DeviceActionTypes.GetClientsCompleted;
  constructor(public data: ClientInterface[]) {}
}

export class GetSites implements Action {
  readonly type = DeviceActionTypes.GetSites;
  constructor(public scwEnv: string, public client: string) {}
}

export class GetSitesCompleted implements Action {
  readonly type = DeviceActionTypes.GetSitesCompleted;
  constructor(public data: SiteInterface[]) {}
}

export class GetLines implements Action {
  readonly type = DeviceActionTypes.GetLines;
  constructor(public scwEnv: string, public client: string, public siteId: number) {}
}

export class GetLinesCompleted implements Action {
  readonly type = DeviceActionTypes.GetLinesCompleted;
  constructor(public data: LineInterface[]) {}
}

export class GetConnectionProfiles implements Action {
  readonly type = DeviceActionTypes.GetConnectionProfiles;
  constructor() {}
}

export class GetConnectionProfilesCompleted implements Action {
  readonly type = DeviceActionTypes.GetConnectionProfilesCompleted;
  constructor(public data: ConnectionProfileInterface[]) {}
}

export class RegisterDevices implements Action {
  readonly type = DeviceActionTypes.RegisterDevices;
  constructor(public payload: number[]) {}
}

export class RegisterDevicesCompleted implements Action {
  readonly type = DeviceActionTypes.RegisterDevicesCompleted;
  constructor(public registeredDevices: any[]) {}
}

export class SendMessageToDevice implements Action {
  readonly type = DeviceActionTypes.SendMessageToDevice;
  constructor(public macAddress: string, public message: string) {}
}

export class SendMessageToDeviceCompleted implements Action {
  readonly type = DeviceActionTypes.SendMessageToDeviceCompleted;
  constructor(public response: any) {}
}

export class GetFirmwares implements Action {
  readonly type = DeviceActionTypes.GetFirmwares;
  constructor() {}
}

export class GetFirmwaresCompleted implements Action {
  readonly type = DeviceActionTypes.GetFirmwaresCompleted;
  constructor(public firmwares: any[]) {}
}

export class UploadFirmware implements Action {
  readonly type = DeviceActionTypes.UploadFirmware;
  constructor(public deviceId: number) {}
}

export class UploadFirmwareCompleted implements Action {
  readonly type = DeviceActionTypes.UploadFirmwareCompleted;
  constructor(public response: any[]) {}
}

export class AbortUploadFirmware implements Action {
  readonly type = DeviceActionTypes.AbortUploadFirmware;
  constructor(public deviceId: number) {}
}

export class AbortUploadFirmwareCompleted implements Action {
  readonly type = DeviceActionTypes.AbortUploadFirmwareCompleted;
  constructor(public response: any[]) {}
}

export class ClearState implements Action {
  readonly type = DeviceActionTypes.ClearState;
}

export class FetchDevicesByMac implements Action {
  readonly type = DeviceActionTypes.FetchDevicesByMac;
  constructor(public macs: string[]) {}
}

export class FetchDevicesByMacCompleted implements Action {
  readonly type = DeviceActionTypes.FetchDevicesByMacCompleted;
  constructor(public results: { mac: string; devices: DeviceInterface[] }[]) {}
}

export class FetchError implements Action {
  readonly type = DeviceActionTypes.FetchError;

  constructor(public payload: any[]) {}
}

export type DeviceActions =
  | GetDevice
  | GetDeviceCompleted
  | GetDeviceForMessageModal
  | GetDeviceForMessageModalCompleted
  | GetDevices
  | GetDevicesCompleted
  | CreateDevice
  | CreateDeviceCompleted
  | UpdateDevice
  | UpdateDeviceCompleted
  | UpdateBulkDevice
  | UpdateBulkDeviceCompleted
  | DeleteDevice
  | DeleteDeviceCompleted
  | SetSelectedFilters
  | SetTableSettings
  | GetDeviceTypes
  | GetDeviceTypesCompleted
  | FetchDevicesByMac
  | FetchDevicesByMacCompleted
  | GetClients
  | GetClientsCompleted
  | GetSites
  | GetSitesCompleted
  | GetLines
  | GetLinesCompleted
  | GetConnectionProfiles
  | GetConnectionProfilesCompleted
  | GetDeviceStatusesForGrid
  | GetDeviceStatusesForGridCompleted
  | RegisterDevices
  | RegisterDevicesCompleted
  | SendMessageToDevice
  | SendMessageToDeviceCompleted
  | GetFirmwares
  | GetFirmwaresCompleted
  | UploadFirmware
  | UploadFirmwareCompleted
  | AbortUploadFirmware
  | AbortUploadFirmwareCompleted
  | ClearState
  | FetchError;

